import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from './page-header/page-header.component';

import { MatImporterModule } from '../mat-importer/mat-importer.module';
import { AppRoutingModule } from '../../app-routing.module';


@NgModule({
  declarations: [PageHeaderComponent],
  imports: [
    CommonModule,
    AppRoutingModule,
    MatImporterModule
  ],
  exports: [
    PageHeaderComponent
  ]
})
export class PageLayoutModule { }
